<nav class="navbar navbar-expand-lg navbar-dark bg-dark px-3">
  <button
    class="navbar-toggler"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#navbarNavNavigation"
    aria-controls="navbarNavNavigation"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarNavNavigation">
    <ul class="navbar-nav me-auto">
      <li class="nav-item" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="[homeRoute]">{{ 'i18n.core.navigation.home' | translate }}</a>
      </li>
      @if(authService.isUserLoggedIn() && authService.isUserAdminOrClientAdmin()) {
      <li class="nav-item dropdown" [routerLinkActive]="['active']">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{ 'i18n.core.navigation.administration' | translate }}
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          @if(authService.isUserAdmin()) {
            <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[clientAdministrationRoute]">
              {{ 'i18n.core.navigation.client-administration' | translate }}
            </a>
            <!-- TODO: remove once dynamic client administration is fully integrated -->
            <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[dynamicClientAdministrationRoute]">
              {{ 'dynamic-client-administration' }}
            </a>
          }
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[userManagementRoute]">
            {{ 'i18n.core.navigation.user-management' | translate }}
          </a>
          <!-- TODO: remove once dynamic user management is fully integrated -->
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[dynamicUserManagementRoute]">
            {{ 'dynamic-user-management' }}
          </a>
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[themeShowcaseRoute]">
            {{ 'i18n.core.navigation.theme-showcase' | translate }}
          </a>
        </div>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="[vehiclesRoute]">{{ 'i18n.core.navigation.vehicles' | translate }}</a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="[samplingProfilesRoute]">{{ 'i18n.core.navigation.sampling-profiles' | translate }}</a>
      </li>
      }
      @if(authService.isUserLoggedIn()) {
      <li class="nav-item dropdown" [routerLinkActive]="['active']">
        <a class="nav-link dropdown-toggle" href="#" id="navbarAnalyticsDropdown" role="button" data-bs-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{ 'i18n.core.navigation.analytics' | translate }}
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarAnalyticsDropdown">
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[runningTotalsRoute]">
            {{ 'i18n.core.navigation.running-totals' | translate }}
          </a>
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[tripOverviewRoute]">
            {{ 'i18n.core.navigation.trip-overview' | translate }}
          </a>
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[statisticEventsRoute]">
            {{ 'i18n.core.navigation.statistic-events' | translate }}
          </a>
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[diagnosticEventsRoute]">
            {{ 'i18n.core.navigation.diagnostic-events' | translate }}
          </a>
          <a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="[periodicStatisticsRoute]">
            {{ 'i18n.core.navigation.periodic-statistics' | translate }}
          </a>
        </div>
      </li>
      }
    </ul>

    <app-language-selector></app-language-selector>
    @if(authService.isUserLoggedIn()) {
      <button ejs-dropdownbutton
            [items]="userNavigation"
            [content]="authService.getUserInfo() ? $safeNavigationMigration(authService.getUserInfo()?.userName): ''"
            [iconCss]="userIcon"
            (select)="onSelection($event)"></button>
    }
  </div>
</nav>
